export const BACKGROUND = '#333333';
export const DIVIDER = '#CCCCCC';
export const BRAND = '#3c6b8b';
